<template>
  <CardTable
    ref="tableRef"
    :is-delete="false"
    name="Car Brand"
    :header="tableHeader"
    endpoint="car-brand"
    :breadcrumbs="breadcrumbs"
    :currentIndex="currentIndex"
    @changeIndex="(index) => (currentIndex = index)"
  >
    <template v-slot:cell-no="{ row }">
      {{ row.no }}
    </template>
    <template v-slot:cell-name="{ row, index }">
      <div v-if="currentIndex !== index">{{ row.name }}</div>
      <div class="d-flex justify-content-center" v-if="currentIndex === index">
        <input type="text" class="like-el-input w-150px" v-model="row.name" />
      </div>
    </template>
    <template v-slot:create>
      <button
        data-bs-toggle="modal"
        data-bs-target="#create"
        class="btn btn-success me-4"
        name="create brand"
      >
        Create
      </button>
    </template>
  </CardTable>

  <div
    ref="modalRef"
    class="modal fade"
    id="create"
    tabindex="-1"
    aria-labelledby="create"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header fs-3">Create New Brand</div>
        <div class="modal-body px-12">
          <form @submit.prevent="null">
            <el-input
              type="text"
              class="mb-3"
              placeholder="Brand"
              v-model="inputRef.name"
            />
            <div class="d-flex justify-content-end">
              <button @click="create()" class="btn btn-primary">Confirm</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import CardTable from '@/components/kt-datatable/CardTable.vue';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import ApiService from '@/core/services/ApiService';
import { hideModal } from '@/core/helpers/dom';
import { reinitializeComponents } from '@/core/plugins/keenthemes';

export default {
  name: 'ManageBrand',
  components: {
    CardTable,
  },
  setup() {
    const breadcrumbs = ['Car & Function', ['Manage Car Brand']];
    const tableHeader = [
      {
        key: 'no',
        name: 'No.',
        sortable: true,
      },
      {
        name: 'Brand',
        key: 'name',
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'actions',
        sortable: false,
      },
    ];

    const currentIndex = ref(-1);
    const inputRef = ref({
      name: '',
    });
    const modalRef = ref(null);
    const tableRef = ref(null);

    const create = async () => {
      await ApiService.post('car-brand', {
        name: inputRef.value.name,
        type: inputRef.value.type,
      });

      hideModal(modalRef.value);

      Swal.fire({
        text: 'New Brand has been created',
        icon: 'success',
        buttonsStyling: false,
        confirmButtonText: 'Return to Brand Lists',
        customClass: {
          confirmButton: 'btn btn-success',
        },
      });

      inputRef.value = {
        name: '',
      };

      await tableRef.value.getData(
        tableRef.value.currentPage,
        tableRef.value.rowsPerPage
      );

      reinitializeComponents();
    };

    return {
      tableHeader,
      breadcrumbs,
      currentIndex,
      inputRef,
      modalRef,
      create,
      tableRef,
    };
  },
};
</script>

<style></style>
